import React from "react";
import { FormikConfig } from "formik";
import { useTranslation } from "react-i18next";
import { history } from "src/services/history";
import { useAppDispatch } from "src/hooks/redux";
import { CloneForm } from "src/page-components/cabinet/my-clones/CloneSettings/CloneForm";
import { ICloneSettingsFormValues } from "src/page-components/cabinet/my-clones/CloneSettings/types";
import { myClonesTrns } from "src/page-components/cabinet/my-clones/trns";
import { CREATE_CLONE_VALIDATION_SCHEMA } from "src/page-components/cabinet/my-clones/CloneSettings/constants/validation";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { scrollTop } from "src/utils/scrollTop";
import { getItemPath } from "src/utils/getItemPath";
import { createCloneAsync } from "src/redux/myClones/actions";
import { PATHNAMES } from "src/constants/routes";
import { CloneType } from "src/@types/cloneTypes";
import { MetadataWrapper } from "src/components/MetadataWrapper";
import { combineSlugId } from "src/utils/combineSlugId";
import { IClone } from "src/@types/clones";

export const INITIAL_VALUES: ICloneSettingsFormValues = {
  clone_type: CloneType.Service,
  company_name: "",
  company_presentation: [],
  google_profile: "",
  industry: "",
  website: "",
  describe_product: "",
  advantages: "",
  investment_for_start: "" as unknown as number,
  employees: "",
  years_on_market: "",
  customers_count: "",
  company_turnover_min: "" as unknown as number,
  company_turnover_max: "" as unknown as number,
  monthly_income_min: "" as unknown as number,
  monthly_income_max: "" as unknown as number,
  ready_to_authorized_capital: true,
  patents_brands: true,
  clone_cost: "" as unknown as number,
  activities: "",
  company_clients: "",
  patents_brands_text: "",
  support_buyer: "",
  information_sold: [],
  access_to_production: true,
  logo: undefined,
  main_photo: undefined,
  additional_information: "",
  prohibited_countries: [],
};

const MyClonesCreate = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const formikProps: FormikConfig<ICloneSettingsFormValues> = {
    initialValues: INITIAL_VALUES,
    validationSchema: CREATE_CLONE_VALIDATION_SCHEMA,
    onSubmit: (values, { resetForm }) => {
      const onSuccess = ({ slug, id }: IClone) => {
        const combinedSlug = combineSlugId(slug, id);
        history.push(getItemPath(PATHNAMES.CLONE_ITEM, { slug: combinedSlug }));
        resetForm();
        scrollTop();
      };
      dispatch(createCloneAsync({ values, onSuccess }));
    },
  };

  return (
    <MetadataWrapper name="my_clones_create">
      <PageWrapper>
        <section className="container py-25">
          <CloneForm
            firstTitle={t(myClonesTrns.whatDoYouWantToCloneTitle)}
            formikProps={formikProps}
            secondTitle={t(myClonesTrns.tellUsAboutYourBusinessTitle)}
          />
        </section>
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default MyClonesCreate;
